export const toAsciiDigits = (value) => String(value ?? "")
  .replace(/[۰-۹]/g, (digit) => String(digit.charCodeAt(0) - 0x6f0))
  .replace(/[٠-٩]/g, (digit) => String(digit.charCodeAt(0) - 0x660));

export function normalizeIranPhone(value) {
  let phone = toAsciiDigits(value).replace(/\D/g, "");
  if (phone.startsWith("0098")) phone = `0${phone.slice(4)}`;
  else if (phone.startsWith("98")) phone = `0${phone.slice(2)}`;
  else if (phone.length === 10 && phone.startsWith("9")) phone = `0${phone}`;
  return phone;
}

const messages = {
  "fetch failed": "ارتباط با سرویس برقرار نشد. کمی بعد دوباره تلاش کنید.",
  "Failed to fetch": "ارتباط با سرویس برقرار نشد. اتصال اینترنت را بررسی کنید.",
  "pricing order not found.": "درخواست پیدا نشد. اطلاعات تماس را دوباره ثبت کنید.",
  "Order request not found.": "درخواست پیدا نشد. اطلاعات تماس را دوباره ثبت کنید.",
  "Invalid verification code.": "کد تأیید درست نیست. دوباره بررسی کنید.",
  "Verification code expired or invalid.": "اعتبار کد تمام شده است. کد جدید درخواست کنید.",
  "Maximum attempts exceeded.": "تعداد تلاش‌های مجاز تمام شد. درخواست تازه‌ای آغاز کنید.",
  "Order request is not pending OTP.": "این درخواست دیگر در انتظار تأیید نیست. درخواست تازه‌ای آغاز کنید.",
  "Please wait before requesting a new OTP.": "برای ارسال دوبارهٔ کد، کمی صبر کنید.",
  "Too Many Requests": "تعداد درخواست‌ها زیاد است. چند دقیقهٔ دیگر دوباره تلاش کنید.",
  "Invalid phone number.": "شمارهٔ موبایل معتبر وارد کنید.",
  "Failed to send SMS.": "ارسال پیامک انجام نشد. کمی بعد دوباره تلاش کنید.",
  "Coin counts must equal the selected quantity.": "جمع تعداد سکه‌ها باید با تیراژ انتخابی برابر باشد.",
};

export function apiErrorMessage(data, fallback = "اطلاعات واردشده را بررسی کنید.") {
  const detail = data?.detail;
  const message = typeof detail === "string" ? detail
    : detail?.message || detail?.detail || data?.message;
  if (typeof message !== "string" || !message.trim()) return fallback;
  return messages[message] || message;
}
